/**
 * TanStack Query hooks for `publisher-url-override`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	publisherUrlOverrideQueryKeys,
	type CreatePublisherUrlOverrideBody,
	type ListPublisherUrlOverrideResponse,
	type PublisherUrlOverrideRow,
} from "./api";

export function usePublisherUrlOverrideList(): UseQueryResult<ListPublisherUrlOverrideResponse, Error> {
	return useQuery({
		queryKey: publisherUrlOverrideQueryKeys.list(),
		queryFn: list,
	});
}

export function usePublisherUrlOverrideCreate(): UseMutationResult<PublisherUrlOverrideRow, Error, CreatePublisherUrlOverrideBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: publisherUrlOverrideQueryKeys.all });
		},
	});
}

export function usePublisherUrlOverrideDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: publisherUrlOverrideQueryKeys.all });
		},
	});
}
